module.exports = __webpack_public_path__ + "img/perfumadaslogo.8268c27e.png";